import { HttpResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ServiceStock } from '../service-stock.service';

@Component({
  selector: 'app-setup-password-confirmation',
  templateUrl: './setup-password-confirmation.component.html',
  styleUrls: ['./setup-password-confirmation.component.scss']
})
export class SetupPasswordConfirmationComponent implements OnInit {

  titleMessage: any;
  messageDesc: any;
  btnTitle: any;

  showCard: boolean = false;
  success: boolean = false;

  constructor(private services: ServiceStock) { }

  ngOnInit() {
    if (sessionStorage.getItem('requestForgotPIN') == '1') {
      sessionStorage.removeItem('requestForgotPIN');
      this.titleMessage = "New PIN is active";
      this.messageDesc = "Your new PIN has been successfully updated.";
      this.btnTitle = "CONTINUE";
      this.showCard = true;
      this.success = true;
    } else if (sessionStorage.getItem('notYourDevice') == '1') {
      sessionStorage.removeItem('notYourDevice');
      this.titleMessage = "Is this your device?";
      this.messageDesc = "It seems, that this device it already registered by a different user. If you think this is wrong, please contact us.";
      this.btnTitle = "Close";
      this.showCard = true;
      this.success = false;
    } else {
      sessionStorage.removeItem('requestForgotPassword');
      let username = sessionStorage.getItem('username');
      let password = this.services.dataStore.getData("password");
      let inputMap = new Map();
      inputMap.set("Body.username", username);
      inputMap.set("Body.password", password);

      this.services.showSpinner();
      this.services.http.fetchApi('/changepassword', 'PUT', inputMap, this.services.getEnvironment().customersPublisher).subscribe(
        async (httpResponse: HttpResponse<any>) => {
          var res = httpResponse.body;
          if (res) {
            let userData = res;
            for (let datakey in userData) {
              if (datakey == 'attributes') {
                let attributes = userData["attributes"] ? userData["attributes"] : {};
                for (let key in attributes) {
                  sessionStorage.setItem(key, attributes[key]);
                  this.services.retailStock.fullUserProfileData[key] = attributes[key];
                }
              } else {
                sessionStorage.setItem(datakey, userData[datakey]);
                this.services.retailStock.fullUserProfileData[datakey] = userData[datakey]
              }
            }

            this.titleMessage = "New Password is active";
            this.messageDesc = "Your new password has been successfully updated.";
            this.btnTitle = "CONTINUE";
            this.showCard = true;
            this.success = true;

            let fullUserProfileData = this.services.retailStock.fullUserProfileData;

            this.services.getUserProfile = fullUserProfileData;
            this.services.userProfile = fullUserProfileData;
            localStorage.setItem('userProfile', JSON.stringify(fullUserProfileData));

            this.services.hideSpinner();
          }
        },
        async (httpError) => {
          var err = httpError['error']
          if (err != null && err['ErrorElementPath'] != undefined && err['ErrorDescription'] != undefined) {
          }

          this.titleMessage = "Something went wrong!";
          this.messageDesc = "There was an unexpected error processing your request. Please contact us";
          this.btnTitle = "Close";
          this.showCard = true;
          this.success = false;
          this.services.hideSpinner();
        }
      )
    }

  }

  gotoContactUs() {
    this.services.router.navigate(['/staging', 'contactUs']);
  }

  continue() {
    let navPath = "welcomeuser";
    if (!this.success) {
      navPath = "appnavigator";
    }
    this.services.router.navigate(['/welcome', navPath]);
  }

}
